import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Screen from '../../assets/images/screen.svg?react';



import {Button, Flex, Grid, Typography, Modal} from 'antd';

const { useBreakpoint } = Grid;
const { Title } = Typography;
const { Paragraph } = Typography;

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    width: 355
  },
  screen: {
    marginBottom: spacing(4)
  },
  title: {
    marginBottom: spacing(2),
    textAlign: 'center'
  }
}));

const MinWidth = () => {
  const classes = useStyles();

  const screen = useBreakpoint();
  const [isOpen, setOpen] = useState(false);
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    const isScreenReady = Object.keys(screen).length > 0;

    if (!isScreenReady) {
      return;
    }

    const isMinWidth = !screen.lg;

    setOpen(isMinWidth);
    setHasMounted(true);
  }, [screen]);

  const handleClose = () => {
    setOpen(false);
  };

  if (!hasMounted) {
    return null;
  }

  return (
    <Modal
      className={classes.root}
      closable={{ 'aria-label': 'Custom Close Button' }}
      open={isOpen}
      onOk={handleClose}
      onCancel={handleClose}
      footer={null}
    >
      <Flex className={classes.screen} justify={'center'} align={'center'}>
        <Screen />
      </Flex>
      <Title level={4} className={classes.title}>
        Используйте экран большего размера
      </Title>
      <Paragraph style={{ textAlign: 'center' }}>
        Для корректного отображения личного кабинета перейдите на устройство с большим экраном:
        планшет или компьютер
      </Paragraph>
      <Button block type="primary" size="large" onClick={handleClose}>
        Хорошо
      </Button>
    </Modal>
  );
};

export default MinWidth;
